import React from 'react';
import ReactDOM from 'react-dom/client';
// import { GoogleOAuthProvider } from "@react-oauth/google";
import './index.css';
import './Mobile.css';
import App from './App';

// const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || "";

const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(
//   <React.StrictMode>
//     <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
//       <App />
//     </GoogleOAuthProvider>,
//   </React.StrictMode>
// );

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
